export const topSearchesSection = {
    title: 'Top Searches',
    links: [
        {
            text: 'Slack Integrations',
            href: '/apps/slack/integrations',
        },
        {
            text: 'Salesforce Integrations',
            href: '/apps/salesforce/integrations',
        },
        {
            text: 'HubSpot CRM Integrations',
            href: '/apps/hubspot/integrations',
        },
        {
            text: 'PayPal Integrations',
            href: '/apps/paypal/integrations',
        },
        {
            text: 'Asana Integrations',
            href: '/apps/asana/integrations',
        },
        {
            text: 'Stripe Integrations',
            href: '/apps/stripe/integrations',
        },
        {
            text: 'GitHub Integrations',
            href: '/apps/github/integrations',
        },
        {
            text: 'Trello Integrations',
            href: '/apps/trello/integrations',
        },
        {
            text: 'Todoist Integrations',
            href: '/apps/todoist/integrations',
        },
        {
            text: 'Xero Integrations',
            href: '/apps/xero/integrations',
        },
        {
            text: 'Facebook Groups Integrations',
            href: '/apps/facebook-groups/integrations',
        },
        {
            text: 'JIRA Integrations',
            href: '/apps/jira-software-server/integrations',
        },
        {
            text: 'Pipedrive Integrations',
            href: '/apps/pipedrive/integrations',
        },
        {
            text: 'Zendesk Integrations',
            href: '/apps/zendesk/integrations',
        },
        {
            text: 'Google Analytics Integrations',
            href: '/apps/google-analytics/integrations',
        },
        {
            text: 'Notion Integrations',
            href: '/apps/notion/integrations',
        },
        {
            text: 'MailChimp Integrations',
            href: '/apps/mailchimp/integrations',
        },
        {
            text: 'Shopify Integrations',
            href: '/apps/shopify/integrations',
        },
        {
            text: 'Intercom Integrations',
            href: '/apps/intercom/integrations',
        },
        {
            text: 'GitLab Integrations',
            href: '/apps/gitlab/integrations',
        },
        {
            text: 'Magento 2.X Integrations',
            href: '/apps/magento-v2/integrations',
        },
        {
            text: 'Google Drive Integrations',
            href: '/apps/google-drive/integrations',
        },
        {
            text: 'WooCommerce Integrations',
            href: '/apps/woocommerce/integrations',
        },
        {
            text: 'Basecamp 3 Integrations',
            href: '/apps/basecamp3/integrations',
        },
    ],
};
export const popularAppsSection = {
    title: 'Popular Apps',
    links: [
        {
            text: 'Dropbox',
            href: '/apps/dropbox/integrations',
        },
        {
            text: 'Google Sheets',
            href: '/apps/google-sheets/integrations',
        },
        {
            text: 'DocuSign',
            href: '/apps/docusign/integrations',
        },
        {
            text: 'WordPress',
            href: '/apps/wordpress/integrations',
        },
        {
            text: 'Office 365',
            href: '/apps/office-365/integrations',
        },
        {
            text: 'QuickBooks Online',
            href: '/apps/quickbooks/integrations',
        },
        {
            text: 'Mixpanel',
            href: '/apps/mixpanel/integrations',
        },
        {
            text: 'RingCentral',
            href: '/apps/ringcentral/integrations',
        },
        {
            text: 'Zoho CRM',
            href: '/apps/zoho-crm/integrations',
        },
        {
            text: 'HubSpot',
            href: '/apps/hubspot/integrations',
        },
        {
            text: 'Microsoft Teams',
            href: '/apps/microsoft-teams/integrations',
        },
        {
            text: 'Eventbrite',
            href: '/apps/eventbrite/integrations',
        },
        {
            text: 'Box',
            href: '/apps/box/integrations',
        },
        {
            text: 'Evernote Business',
            href: '/apps/evernote-business/integrations',
        },
        {
            text: 'LinkedIn',
            href: '/apps/linkedin/integrations',
        },
        {
            text: 'Marketo',
            href: '/apps/marketo/integrations',
        },
        {
            text: 'ChatGPT',
            href: '/apps/chatgpt/integrations',
        },
        {
            text: 'Twilio',
            href: '/apps/twilio/integrations',
        },
        {
            text: 'Keap',
            href: '/apps/keap-max-classic/integrations',
        },
        {
            text: 'Google Forms',
            href: '/apps/google-forms/integrations',
        },
        {
            text: 'SurveyMonkey',
            href: '/apps/surveymonkey/integrations',
        },
        {
            text: 'Campaign Monitor',
            href: '/apps/campaign-monitor/integrations',
        },
        {
            text: 'Pardot',
            href: '/apps/pardot/integrations',
        },
        {
            text: 'Microsoft Dynamics CRM',
            href: '/apps/microsoft-dynamics-crm/integrations',
        },
    ],
};
export const trendingAppsSection = {
    title: 'Trending Apps',
    links: [
        {
            text: 'Twitch',
            href: '/apps/twitch/integrations',
        },
        {
            text: 'Calendly',
            href: '/apps/calendly/integrations',
        },
        {
            text: 'Microsoft To-Do',
            href: '/apps/microsoft-todo/integrations',
        },
        {
            text: 'Microsoft Outlook',
            href: '/apps/microsoft-outlook/integrations',
        },
        {
            text: 'Medium',
            href: '/apps/medium/integrations',
        },
        {
            text: 'Unbounce',
            href: '/apps/unbounce/integrations',
        },
        {
            text: 'Freshdesk',
            href: '/apps/freshdesk/integrations',
        },
        {
            text: 'Airtable',
            href: '/apps/airtable/integrations',
        },
        {
            text: 'Expensify',
            href: '/apps/expensify/integrations',
        },
        {
            text: 'Insightly',
            href: '/apps/insightly/integrations',
        },
        {
            text: 'PagerDuty',
            href: '/apps/pagerduty/integrations',
        },
        {
            text: 'Podio',
            href: '/apps/podio/integrations',
        },
        {
            text: 'OpenAI',
            href: '/apps/openai/integrations',
        },
        {
            text: 'Square',
            href: '/apps/square/integrations',
        },
        {
            text: 'Datadog',
            href: '/apps/datadog/integrations',
        },
        {
            text: 'Toggl',
            href: '/apps/toggl/integrations',
        },
        {
            text: 'Facebook Lead Ads',
            href: '/apps/facebook-lead-ads/integrations',
        },
        {
            text: 'Rocket.Chat',
            href: '/apps/rocketchat/integrations',
        },
        {
            text: 'Firebase',
            href: '/apps/firebase/integrations',
        },
        {
            text: 'AWS Lambda',
            href: '/apps/aws-lambda/integrations',
        },
        {
            text: 'MINDBODY',
            href: '/apps/mindbody/integrations',
        },
        {
            text: 'Harvest',
            href: '/apps/harvest/integrations',
        },
        {
            text: 'Smartsheet',
            href: '/apps/smartsheet/integrations',
        },
        {
            text: 'Teamwork Desk',
            href: '/apps/teamwork-desk/integrations',
        },
        {
            text: 'Yammer',
            href: '/apps/yammer/integrations',
        },
        {
            text: 'Typeform',
            href: '/apps/typeform/integrations',
        },
        {
            text: 'Autotask',
            href: '/apps/autotask/integrations',
        },
        {
            text: 'Wrike',
            href: '/apps/wrike/integrations',
        },
        {
            text: 'Help Scout',
            href: '/apps/help-scout/integrations',
        },
        {
            text: 'Braintree',
            href: '/apps/braintree/integrations',
        },
    ],
};
export const topAppsByCategorySection = {
    title: 'Top Apps by Category',
    links: [
        {
            text: 'Project Management',
            href: '/apps/categories/project-management',
        },
        {
            text: 'Calendar',
            href: '/apps/categories/calendar',
        },
        {
            text: 'Email',
            href: '/apps/categories/email',
        },
        {
            text: 'CRM (Customer Relationship Management)',
            href: '/apps/categories/crm',
        },
        {
            text: 'Marketing Automation',
            href: '/apps/categories/marketing',
        },
        {
            text: 'Notes',
            href: '/apps/categories/notes',
        },
        {
            text: 'Accounting',
            href: '/apps/categories/accounting',
        },
        {
            text: 'Social Media Marketing',
            href: '/apps/categories/social-marketing',
        },
        {
            text: 'Online Courses',
            href: '/apps/categories/it-operations-education',
        },
        {
            text: 'Contact Management',
            href: '/apps/categories/contacts',
        },
        {
            text: 'Forms & Surveys',
            href: '/apps/categories/forms',
        },
        {
            text: 'Scheduling & Booking',
            href: '/apps/categories/scheduling',
        },
        {
            text: 'Task Management',
            href: '/apps/categories/todo-lists',
        },
        {
            text: 'Databases',
            href: '/apps/categories/databases',
        },
        {
            text: 'Call Tracking',
            href: '/apps/categories/call-tracking',
        },
        {
            text: 'Documents',
            href: '/apps/categories/documents',
        },
        {
            text: 'Fax',
            href: '/apps/categories/fax',
        },
        {
            text: 'Files',
            href: '/apps/categories/files',
        },
        {
            text: 'Customer Support',
            href: '/apps/categories/customer-support',
        },
        {
            text: 'Team Collaboration',
            href: '/apps/categories/team-collaboration',
        },
        {
            text: 'Spreadsheets',
            href: '/apps/categories/spreadsheets',
        },
        {
            text: 'Website Builders',
            href: '/apps/categories/cms',
        },
        {
            text: 'Ecommerce',
            href: '/apps/categories/ecommerce',
        },
        {
            text: 'Event Management',
            href: '/apps/categories/event-management',
        },
    ],
};
export const ourBestContentSection = {
    title: 'Our Best Content',
    links: [
        {
            text: 'Best Video Conferencing Apps',
            href: '/blog/best-video-conferencing-apps/',
        },
        {
            text: 'Best Email Apps',
            href: '/blog/best-email-app/',
        },
        {
            text: 'Best CRM Apps',
            href: '/blog/best-crm-app/',
        },
        {
            text: 'Best Note Taking Apps',
            href: '/blog/best-note-taking-apps/',
        },
        {
            text: 'Best Calendar Apps',
            href: '/blog/best-calendar-apps/',
        },
        {
            text: 'Best Meeting Scheduler Apps',
            href: '/blog/best-meeting-scheduler-apps/',
        },
        {
            text: 'Best Todo List Apps',
            href: '/blog/best-todo-list-apps/',
        },
        {
            text: 'Best Powerpoint Alternatives',
            href: '/blog/best-powerpoint-alternatives/',
        },
        {
            text: 'Best Spreadsheet & Excel Alternatives',
            href: '/blog/best-spreadsheet-excel-alternative/',
        },
        {
            text: 'Best Time Tracking Apps',
            href: '/blog/best-time-tracking-apps/',
        },
        {
            text: 'Best eCommerce Shopping Cart Software',
            href: '/blog/best-ecommerce-shopping-cart-software/',
        },
        {
            text: 'Best Survey Apps',
            href: '/blog/best-survey-apps/',
        },
        {
            text: 'Best Online Form Builder Software',
            href: '/blog/best-online-form-builder-software/',
        },
        {
            text: 'Best Digital Signature Apps',
            href: '/blog/best-digital-signature-apps/',
        },
        {
            text: 'Best Team Chat App',
            href: '/blog/best-team-chat-app/',
        },
        {
            text: 'Workato vs. Zapier',
            href: '/l/workato-vs-zapier/',
        },
    ],
};
const helpfulLinks = [
    { text: 'Pricing', href: '/pricing' },
    { text: 'Help', href: 'https://help.zapier.com/hc/en-us' },
    { text: 'Developer Platform', href: '/platform' },
    { text: 'Press', href: '/press' },
    { text: 'Jobs', href: '/jobs' },
    {
        text: 'Enterprise',
        href: '/enterprise',
    },
    { text: 'Templates', href: '/templates' },
];
const metaLinks = [
    { text: 'Legal', href: '/legal' },
    { text: 'Privacy', href: '/privacy' },
];
const socialIcons = [
    {
        color: '#3b5998',
        svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229"/></svg>`,
        href: 'http://www.facebook.com/ZapierApp?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier',
        title: 'Follow us on Facebook',
    },
    {
        color: '#0976b4',
        svg: `<svg viewBox="0 0 44 40" xmlns="http://www.w3.org/2000/svg"><path d="M44 40h-9.725V25.938c0-3.68-1.52-6.193-4.866-6.193-2.558 0-3.981 1.696-4.643 3.33-.249.586-.21 1.403-.21 2.22V40h-9.634s.124-24.909 0-27.173h9.634v4.265c.57-1.865 3.648-4.526 8.56-4.526C39.211 12.566 44 16.474 44 24.89V40zM5.18 9.428h-.063C2.013 9.428 0 7.351 0 4.718 0 2.034 2.072 0 5.239 0c3.164 0 5.11 2.029 5.171 4.71 0 2.633-2.007 4.718-5.23 4.718zm-4.07 3.399h8.576V40H1.11V12.827z" fill-rule="evenodd"/></svg>`,
        href: 'https://www.linkedin.com/company/zapier/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier',
        title: 'Follow us on LinkedIn',
    },
    {
        color: '#00aced',
        svg: `<svg viewBox="0 0 48 40" xmlns="http://www.w3.org/2000/svg"><path d="M48 4.735a19.235 19.235 0 0 1-5.655 1.59A10.076 10.076 0 0 0 46.675.74a19.395 19.395 0 0 1-6.257 2.447C38.627 1.225 36.066 0 33.231 0c-5.435 0-9.844 4.521-9.844 10.098 0 .791.085 1.56.254 2.3C15.456 11.974 8.2 7.96 3.34 1.842a10.281 10.281 0 0 0-1.33 5.083c0 3.502 1.738 6.593 4.38 8.405a9.668 9.668 0 0 1-4.462-1.26v.124c0 4.894 3.395 8.977 7.903 9.901a9.39 9.39 0 0 1-2.595.356 9.523 9.523 0 0 1-1.854-.18c1.254 4.01 4.888 6.932 9.199 7.01-3.37 2.71-7.618 4.325-12.23 4.325-.795 0-1.58-.047-2.35-.139C4.359 38.327 9.537 40 15.096 40c18.115 0 28.019-15.385 28.019-28.73 0-.439-.009-.878-.026-1.308A20.211 20.211 0 0 0 48 4.735" fill-rule="evenodd"/></svg>`,
        href: 'https://twitter.com/?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier#!/zapier',
        title: 'Follow @zapier on Twitter',
    },
    {
        color: '#e52d27',
        svg: `<svg viewBox="0 0 48 34" xmlns="http://www.w3.org/2000/svg"><path d="M19.044 23.27l-.002-13.582 12.97 6.814-12.968 6.768zM47.52 7.334s-.47-3.33-1.908-4.798C43.786.61 41.74.601 40.803.49 34.086 0 24.011 0 24.011 0h-.022S13.914 0 7.197.49c-.939.11-2.983.12-4.81 2.045C.948 4.003.48 7.334.48 7.334S0 11.247 0 15.158v3.668c0 3.912.48 7.823.48 7.823s.468 3.331 1.907 4.798c1.827 1.926 4.225 1.866 5.293 2.067C11.52 33.885 24 34 24 34s10.086-.015 16.803-.505c.938-.113 2.983-.122 4.809-2.048 1.438-1.467 1.908-4.798 1.908-4.798s.48-3.91.48-7.823v-3.668c0-3.911-.48-7.824-.48-7.824z" fill-rule="evenodd"/></svg>`,
        href: 'https://www.youtube.com/user/ZapierApp/videos?utm_source=zapier.com&amp;utm_medium=referral&amp;utm_campaign=zapier',
        title: 'See helpful Zapier videos on Youtube',
    },
    {
        color: 'var(--zds-brand-orange, #FF4F00)',
        svg: `<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M576 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm512 123q2 28-17 48-18 21-47 21H889q-25 0-43-16.5t-20-41.5q-22-229-184.5-391.5T250 902q-25-2-41.5-20T192 839V704q0-29 21-47 17-17 43-17h5q160 13 306 80.5T826 902q114 113 181.5 259t80.5 306zm512 2q2 27-18 47-18 20-46 20h-143q-26 0-44.5-17.5T1329 1476q-12-215-101-408.5t-231.5-336-336-231.5T252 398q-25-1-42.5-19.5T192 335V192q0-28 20-46 18-18 44-18h3q262 13 501.5 120T1186 542q187 186 294 425.5t120 501.5z"/></svg>`,
        href: '/blog/feeds/latest/',
        title: 'Subscribe to our blog',
    },
];
export const footerV3FallbackData = {
    socialIcons: socialIcons,
    metaLinks: metaLinks,
    helpfulLinks: helpfulLinks,
    seoLinks: {
        topSearches: topSearchesSection,
        popularApps: popularAppsSection,
        trendingApps: trendingAppsSection,
        topAppsByCategory: topAppsByCategorySection,
        ourBestContent: ourBestContentSection,
    },
};
//# sourceMappingURL=fallbackData.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
